<template>
  <div class="row">
    <div v-if="!load" class="col-lg-12 center">
      <sweetalert-icon icon="loading" />
    </div>
    <div v-if="load" class="col-lg-12">
      <div class="row">
        <div class="col-lg-3 col-xs-12 mt-4" v-for="video in videos" :key="video.id">
          <div class="pointer" @click="getVideo(video.id)">
            <img :src="video.image" class="full" />
            <p class="mb-0">{{video.name}}</p>
            <span class="color_light_gallery">{{video.description}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Form from "@/Recruiters/Galleries/Form.vue";
export default {
  props: ["videos"],
  data: () => ({
    load: true
  }),
  mounted() {
    eventBus.$on("chooseFormVideo", video => {
      eventBus.$emit("searchVideoList", true);
    });
  },
  methods: {
    getVideo(id) {
      axios.get(`/recruiters/galleries/videos/${id}`).then(response => {
        this.openForm(response.data.item, response.data.gallery);
      });
    },
    openForm(video, gallery) {
      this.$modal.show(
        Form,
        {
          video: video,
          gallery: gallery,
          delete_action: false
        },
        {
          width: "75%",
          height: "auto",
          scrollable: true
        }
      );
    }
  }
};
</script>

<style>
</style>